export default __webpack_public_path__ + "static/media/RideTheCity.a3f747fb.png";